// NavTab.js - Shared body for every header nav pill (icon + optional
// label), used by HeaderNavigation.js (StudentNavButtons/TeacherNavButtons)
// and HeaderNavDropdown.js so the active/compact/disabled pattern is
// written once.

import React from 'react';
import { Text, TouchableOpacity } from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';

import { HEADER } from './headerTheme';

// `as` lets callers choose the walkthrough-wrapped touchable or a plain
// one; every other touchable prop (onPress, disabled, accessibilityLabel,
// accessibilityRole, accessibilityState, title, testID, ...) is forwarded
// unchanged. `trailingIcon` renders a small icon after the label (or right
// after the leading icon when labels are hidden) — used by
// HeaderNavDropdown for its chevron. It is omitted entirely when not
// passed, so plain nav tabs are unaffected.
const NavTab = ({
  as: Component = TouchableOpacity,
  isActive,
  showLabels,
  // Style-only dimming. Usually mirrors the `disabled` touchable prop, but
  // kept as its own flag so a tab can be dimmed without also being disabled
  // (or vice versa) if a future caller needs that.
  dimmed = false,
  iconName,
  label,
  trailingIcon,
  styles: h,
  ...touchableProps
}) => (
  <Component
    {...touchableProps}
    style={[
      h.navTab,
      !showLabels && h.navTabCompact,
      isActive && h.navTabActive,
      dimmed && { opacity: 0.5 },
    ]}
  >
    <MaterialCommunityIcons
      name={iconName}
      size={HEADER.iconSize}
      color={isActive ? HEADER.brandDeep : HEADER.onBrand}
    />
    {showLabels && (
      <Text style={[h.navTabLabel, isActive && h.navTabLabelActive]}>{label}</Text>
    )}
    {trailingIcon && (
      <MaterialCommunityIcons
        name={trailingIcon}
        size={16}
        color={isActive ? HEADER.brandDeep : HEADER.onBrand}
      />
    )}
  </Component>
);

export default NavTab;
